import { render, staticRenderFns } from "./CateringDetail.vue?vue&type=template&id=10ae93d1&scoped=true&"
import script from "./CateringDetail.vue?vue&type=script&lang=js&"
export * from "./CateringDetail.vue?vue&type=script&lang=js&"
import style0 from "./CateringDetail.vue?vue&type=style&index=0&id=10ae93d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae93d1",
  null
  
)

export default component.exports